// Utility to export MLM User Report to Excel
// Fills null/empty values with 'N/A'
export const handleMLMUserReportExportToExcel = (userList, status) => {
    if (!userList || userList.length === 0) return;
    import("xlsx").then(XLSX => {
        // Fill null/empty with 'N/A'
        const filled = userList.map(row => {
            const newRow = {};
            Object.keys(row).forEach(key => {
                let val = row[key];
                if (val === null || val === undefined || val === "") {
                    newRow[key] = "N/A";
                } else {
                    newRow[key] = val;
                }
            });
            return newRow;
        });
        const ws = XLSX.utils.json_to_sheet(filled);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "MLM Users");
        XLSX.writeFile(wb, `MLM_User_Report_${status}_${new Date().toISOString().slice(0,10)}.xlsx`);
    });
};
